export const methods = {
  HistoricalSessionAddressCount: "HistoricalSessionAddressCount", // users count today
  HistoricalSessionBytes: "HistoricalSessionBytes", //data consumed today
  CurrentSessionCount: "CurrentSessionCount", // total users count
  CurrentNodeCount: "CurrentNodeCount", // total nodes count
  CurrentSessionAddressCount: "CurrentSessionAddressCount", //total users
  TotalSessionBytes: "TotalSessionBytes", // total data consumed
};
